/**
 * region for libraries*/
import React, { Component } from 'react';
import { Modal, ModalHeader } from 'reactstrap';

/**
 * region for componets*/
import { Step0 } from './Wizard/Step0';
import { Step1 } from './Wizard/Step1';

export class WizardAddKeywordModal extends Component {
    static displayName = WizardAddKeywordModal.name;
    constructor(props) {
        super(props);

        this.state = {
            show: true,
            showAddKeywordModal: this.props.showAddKeywordModal,
            keywordText: props.keywordText,
            currentStep: props.currentStep,
            saveInModalView: props.saveInModalView ?? false
        };

        this.close = this.close.bind(this);
        this.refreshRelateKeywords = this.refreshRelateKeywords.bind(this);
        this.finalStep = 1;
    }

    handleNext(event, data) {
        if (this.state.currentStep === this.finalStep) {
            this.saveData();
        }
        else {
            this.setState({ currentStep: this.state.currentStep + 1 });
        }
    }

    handlekeywordTextUpdated(keywordText) {
        const self = this;
        self.setState({
            keywordText: keywordText
        });
    }

    close() {
        this.setState({
            show: false
        });
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    refreshRelateKeywords() {
        this.setState({
            show: false
        });
        if (this.props.refreshRelateKeywords) {
            this.props.refreshRelateKeywords();
        }
    }

    returnObjects = (items) => {
        if (this.props.returnObjects) {
        this.props.returnObjects(items);
        }
    }

    render() {

        let showCurrentStep;

        if (this.state.currentStep === 0) {
            showCurrentStep = <Step0 keywordText={this.state.keywordText}
                onClose={this.close.bind(this)}
                handleNext={this.handleNext.bind(this)}
                currentStep={this.state.currentStep}
                onkeywordTextUpdated={this.handlekeywordTextUpdated.bind(this)} />
        } else if (this.state.currentStep === 1) {
            showCurrentStep = <Step1 keywordText={this.state.keywordText}
                keywordsSelect={this.props.keywordsSelect}
                onClose={this.close.bind(this)}
                onRefreshRelateKeywords={this.refreshRelateKeywords.bind(this)}
                handleNext={this.handleNext.bind(this)}
                currentStep={this.state.currentStep} 
                saveInModalView={this.state.saveInModalView}
                returnObjects={this.returnObjects}       
                />
        }

        return (
            <Modal zIndex={9999} isOpen={this.state.show} toggle={this.close} className={this.props.className}>
                <ModalHeader toggle={this.close}>{this.props.titleHeader}</ModalHeader>
                {showCurrentStep}
            </Modal>
        );
    }
}
